import { queries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";
import { renalReplacementTherapyTypeMessages } from "lib/build/forms/ktx/basic-registration-data/waiting-list-data/renalReplacementTherapy";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventByQuery } from "src/features/events";

export function useRenalReplacementTherapy(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<string>(queries.renalReplacementTherapy);
	const formatMessageMap = useFormatMessageMap();
	return event === undefined
		? { value: "-" }
		: {
				value: formatMessageMap(
					renalReplacementTherapyTypeMessages,
					event.value
				),
				timestamp: event.timestamp,
				origin: event.origin
			};
}
